<template lang="pug">
  router-view(:value="value")
</template>

<script>
export default {
  name: 'CardTabHistory',
  props: {
    sidPerson: { type: [String, Number], required: true },
    /**
     * @param {Object} POST /bcards のレスポンスのうち1件またはGET /persons/overview
     */
    value: { type: Object, required: true }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabHistory.vue